import { Shield } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import heroImage from "@/assets/insurance-claims.jpg";

const InsuranceClaims = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Business Insurance Claim Representation</h2>
          <p className="text-lg text-muted-foreground">
            Legal representation for denied or underpaid business insurance claims in Texas. We fight for fair compensation for property damage, business interruption, liability, and other commercial insurance disputes.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Insurance Claims" subtitle="Fight for Your Business Coverage" icon={<Shield className="h-16 w-16 text-accent" />} mainContent={mainContent} heroImage={heroImage} />;
};
export default InsuranceClaims;